<dialog-header
  [title]="dialogTitle"
  (onClose)="matDialogRef.close()"
></dialog-header>

<div
  mat-dialog-content
  *ngIf="!loading"
  style="
    padding-bottom: 20px;
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: var(--app-container);
  "
>
  <mat-tab-group
    *ngIf="!singleSectionDialog; else singleSectionContent"
    mat-align-tabs="start"
    mat-stretch-tabs="false"
    disableRipple="true"
    [animationDuration]="0"
    [(selectedIndex)]="selectedIndex"
    (selectedTabChange)="tabChanged($event.index)"
  >
    <mat-tab label="Promotions">
      <ng-container *ngTemplateOutlet="promotionsContent"></ng-container>
    </mat-tab>

    <mat-tab label="Birthday Club">
      <ng-container *ngTemplateOutlet="birthdayClubContent"></ng-container>
    </mat-tab>
  </mat-tab-group>

  <ng-template #singleSectionContent>
    <ng-container
      *ngTemplateOutlet="
        selectedTab === 'promotions' ? promotionsContent : birthdayClubContent
      "
    ></ng-container>
  </ng-template>

  <ng-template #promotionsContent>
    <div style="overflow: hidden">
      <div style="margin-top: 20px" *ngIf="hasPromotionsAccess">
        <!--CREATE PROMOTION-->
        <div
          class="promotion-create-container"
          style="
            background-color: white;
            border-radius: 10px;
            padding: 20px;
            margin-top: 20px;
          "
        >
          <div
            class="form-field-label"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-weight: 600;
              font-size: 16px;
              margin-bottom: 20px;
            "
          >
            Create a new promotion
          </div>

          <form [formGroup]="promoForm">
            <div
              class="promotion-form-row"
              style="display: flex; justify-content: space-between; gap: 10px"
            >
              <div class="form-field promotion-form-field" style="flex: 1">
                <single-select
                  label="Loyalty Card"
                  [formCtrl]="cardFormControl"
                  [options]="cards"
                  [value]="cardFormControl.value"
                  [inBrackets]="'info'"
                  property="title"
                  [showIcon]="false"
                  (selected)="stampsFormControl.reset()"
                ></single-select>
              </div>

              <div
                class="form-field promotion-form-field"
                style="flex: 1"
                *ngIf="cardFormControl?.value"
              >
                <single-select
                  *ngIf="cardFormControl?.value?.cardType === 'stamp'"
                  [label]="'Stamps per scan'"
                  [formCtrl]="stampsFormControl"
                  [options]="stampNumbers"
                  [value]="stampsFormControl.value"
                >
                </single-select>

                <div *ngIf="cardFormControl?.value?.cardType !== 'stamp'">
                  <div class="form-field-label">Points per scan</div>
                  <input
                    class="form-input"
                    autocomplete="off"
                    [maxlength]="5"
                    [formControl]="stampsFormControl"
                    type="number"
                    oninput="
                      javascript: if (this.value.length > this.maxLength)
                        this.value = this.value.slice(0, this.maxLength);
                    "
                  />
                </div>
              </div>
            </div>

            <div
              *ngIf="cardFormControl?.value && stampsFormControl?.value"
              class="promotion-form-row"
              style="display: flex; justify-content: space-between; gap: 10px"
            >
              <div class="form-field promotion-form-field" style="flex: 1">
                <div>
                  <div class="form-field-label">
                    Start Date<span style="color: red">*</span>
                  </div>
                  <input
                    id="datetime-local-field"
                    class="form-input"
                    autocomplete="off"
                    [formControl]="fromDateFormControl"
                    type="date"
                    [min]="minDate"
                  />
                </div>
              </div>

              <div
                class="form-field promotion-form-field"
                style="flex: 1"
                [matTooltip]="
                  fromTimes.length === 0 ? 'No times available for today' : ''
                "
              >
                <single-select
                  label="Start Time"
                  [formCtrl]="fromTimeFormControl"
                  [options]="fromTimes"
                  [value]="fromTimeFormControl.value"
                  [showIcon]="false"
                ></single-select>
              </div>
            </div>

            <div
              *ngIf="cardFormControl?.value && stampsFormControl?.value"
              class="promotion-form-row"
              style="display: flex; justify-content: space-between; gap: 10px"
            >
              <div class="form-field promotion-form-field" style="flex: 1">
                <div>
                  <div class="form-field-label">
                    End Date<span style="color: red">*</span>
                  </div>
                  <input
                    id="datetime-local-field"
                    class="form-input"
                    autocomplete="off"
                    [formControl]="toDateFormControl"
                    type="date"
                    [min]="fromDateFormControl.value"
                  />
                </div>
              </div>

              <div class="form-field promotion-form-field" style="flex: 1">
                <single-select
                  label="End Time"
                  [formCtrl]="toTimeFormControl"
                  [options]="toTimes"
                  [value]="toTimeFormControl.value"
                  [showIcon]="false"
                ></single-select>
              </div>
            </div>
          </form>

          <div
            class="promotion-actions-row"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              gap: 40px;
              flex-wrap: wrap;
            "
          >
            <div style="font-size: 14px; color: gray; flex: 1; min-width: 0">
              <i *ngIf="promoSummary" style="overflow: hidden; display: block">
                {{ promoSummary }}
              </i>
            </div>
            <div style="white-space: nowrap; margin-top: 10px">
              <app-secondary-button
                *ngIf="cardFormControl?.value"
                style="margin-right: 10px"
                [title]="'Cancel'"
                [disabled]="false"
                (tapped)="reset()"
              ></app-secondary-button>
              <app-primary-button
                [disabled]="!promoForm.valid"
                [title]="'Create'"
                (tapped)="savePromotion()"
                bgColor="var(--app-timber)"
                color="white"
              ></app-primary-button>
            </div>
          </div>
        </div>

        <!--LIVE PROMOTIONS-->
        <div *ngIf="livePromotions?.length">
          <div
            class="form-field-label"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-weight: 500;
              font-size: 16px;
              margin-top: 20px;
            "
          >
            Active Promotions
          </div>

          <div
            style="
              display: flex;
              overflow-x: auto;
              padding-bottom: 10px;
              gap: 10px;
              margin-top: 10px;
            "
          >
            <promotion-card
              *ngFor="let promo of livePromotions"
              [promo]="promo"
              [promoState]="'live'"
              (deletePromotion)="deletePromotion($event)"
            ></promotion-card>
          </div>
        </div>

        <!--UPCOMING PROMOTIONS-->
        <div *ngIf="upcomingPromotions?.length">
          <div
            class="form-field-label"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-weight: 500;
              font-size: 16px;
              margin-top: 20px;
            "
          >
            Upcoming Promotions
          </div>

          <div
            style="
              display: flex;
              overflow-x: auto;
              padding-bottom: 10px;
              gap: 10px;
              margin-top: 10px;
            "
          >
            <promotion-card
              *ngFor="let promo of upcomingPromotions"
              [promo]="promo"
              [promoState]="'upcoming'"
              (deletePromotion)="deletePromotion($event)"
            ></promotion-card>
          </div>
        </div>

        <!--EXPIRED PROMOTIONS-->
        <div *ngIf="expiredPromotions?.length">
          <div
            class="form-field-label"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-weight: 500;
              font-size: 16px;
              margin-top: 20px;
            "
          >
            Expired Promotions
          </div>

          <div
            style="
              display: flex;
              overflow-x: auto;
              padding-bottom: 10px;
              gap: 10px;
              margin-top: 10px;
            "
          >
            <promotion-card
              *ngFor="let promo of expiredPromotions"
              [promo]="promo"
              [promoState]="'expired'"
            ></promotion-card>
          </div>
        </div>
      </div>
    </div>

    <div class="birthday-club-disabled" *ngIf="!hasPromotionsAccess">
      <img
        src="../../../../assets/padlock.png"
        width="80px"
        style="margin-bottom: 20px"
      />

      <p style="margin-bottom: 20px; font-weight: bold; font-size: 16px">
        {{ titlePromotions }}
      </p>

      <p style="margin-bottom: 20px">
        {{ subtitlePromotions }}
      </p>

      <app-primary-button
        *ngIf="canEngage"
        [title]="'Upgrade Now'"
        (tapped)="seePlans()"
        bgColor="var(--app-timber)"
        color="white"
      ></app-primary-button>
    </div>
  </ng-template>

  <ng-template #birthdayClubContent>
    <div style="overflow: hidden">
      <div style="margin-top: 20px" *ngIf="hasBirthdayClubAccess">
        <app-info-box
          title=""
          [canDismiss]="false"
          [body]="infoBoxBody"
        ></app-info-box>

        <link-text
          text="How do customers join my Birthday Club?"
          (onTapped)="openBirthdayInfoDialog()"
        ></link-text>
      </div>

      <div class="birthday-club-enabled" *ngIf="hasBirthdayClubAccess">
        <div
          class="form-field"
          style="
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div class="form-field-label" style="margin-bottom: 0px">
            {{ birthdayClubEnabled ? "Enabled" : "Disabled" }}
          </div>
          <mat-slide-toggle
            [disabled]="false"
            [checked]="birthdayClubEnabled"
            (change)="birthdayClubEnabled = !birthdayClubEnabled"
          >
          </mat-slide-toggle>
        </div>

        <div *ngIf="birthdayClubEnabled">
          <form [formGroup]="birthdayForm">
            <div class="form-field" style="margin-top: 20px">
              <div
                class="form-field-label"
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <div>Message<span style="color: red">*</span></div>
                <span style="font-size: 12px; font-weight: normal"
                  >{{ birthdayPnMessageFormControl.value?.length || 0 }}/{{
                    contentMaxChar
                  }}</span
                >
              </div>

              <textarea
                class="form-input"
                autocomplete="off"
                [formControl]="birthdayPnMessageFormControl"
                placeholder="e.g. Happy Birthday [customer_name] 🎉"
                type="text"
                oninput="
                  javascript: if (this.value.length > this.maxLength)
                    this.value = this.value.slice(0, this.maxLength);
                "
                [maxlength]="contentMaxChar"
                [rows]="3"
                (click)="updateCursorPosition($event)"
                (keyup)="updateCursorPosition($event)"
                (select)="updateCursorPosition($event)"
              ></textarea>

              <div
                style="
                  margin-top: 5px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                <div
                  class="emoji-button"
                  (click)="openEmojiPicker()"
                  style="min-width: 74px; margin-right: 10px"
                >
                  😊 Emoji
                </div>

                <div
                  class="emoji-button"
                  (click)="insertCustomerNameAtCursor()"
                >
                  + Customer Name
                </div>
              </div>
            </div>

            <div class="form-field" style="margin-top: 20px">
              <single-select
                [label]="'When to send'"
                [formCtrl]="whenToSendFormControl"
                property="name"
                [options]="options"
                [value]="whenToSendFormControl.value"
                [showIcon]="false"
              ></single-select>
            </div>

            <div
              class="form-field"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 20px;
              "
            >
              <div class="form-field-label" style="margin-bottom: 0px">
                Include a reward
              </div>
              <mat-slide-toggle
                [disabled]="false"
                [checked]="birthdayIncludeReward"
                (change)="toggleReward()"
              >
              </mat-slide-toggle>
            </div>

            <div
              #birthdayRewardSection
              style="margin-top: 20px"
              *ngIf="birthdayIncludeReward"
            >
              <div class="form-field">
                <single-select
                  [label]="'Reward type'"
                  [formCtrl]="birthdayRewardTypeFormControl"
                  property="name"
                  [options]="birthdayRewardTypeOptions"
                  [value]="birthdayRewardTypeFormControl.value"
                  [showIcon]="false"
                  (selected)="onBirthdayRewardTypeSelected($event)"
                ></single-select>
              </div>

              <div
                #birthdayRewardTypeDetailSection
                style="margin-top: 20px"
                *ngIf="selectedBirthdayRewardType === 'reward'"
              >
                <choose-reward
                  *ngIf="!birthdayRewards?.length"
                  (clicked)="openRewardDialog()"
                  [label]="'Choose Reward'"
                  [icon]="'redeem'"
                ></choose-reward>
              </div>
              <div
                class="social-container"
                *ngFor="let item of birthdayRewards"
                style="
                  margin-top: 10px;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <div style="display: flex; align-items: center">
                  <div
                    class="form-field-label"
                    style="
                      margin-bottom: 0px !important;
                      color: black;
                      font-size: 16px;
                    "
                  >
                    {{ item?.reward?.title }}
                  </div>
                </div>

                <mat-icon
                  style="color: red; cursor: pointer"
                  (click)="removeReward(item)"
                  >cancel
                </mat-icon>
              </div>

              <div
                #birthdayRewardTypeDetailSection
                class="form-field"
                style="margin-top: 20px"
                *ngIf="
                  selectedBirthdayRewardType === 'points' ||
                  selectedBirthdayRewardType === 'stamps'
                "
              >
                <single-select
                  [label]="birthdayCardLabel"
                  [formCtrl]="birthdayCardFormControl"
                  [options]="birthdayCardOptions"
                  [value]="birthdayCardFormControl.value"
                  property="title"
                  [inBrackets]="'info'"
                  [showIcon]="false"
                  (selected)="onBirthdayCardSelected()"
                ></single-select>

                <div
                  style="margin-top: 8px; font-size: 12px; color: grey"
                  *ngIf="!birthdayCardOptions.length"
                >
                  No eligible
                  {{
                    selectedBirthdayRewardType === "points"
                      ? "open ended points cards"
                      : "stamp cards"
                  }}
                  available.
                </div>

                <div
                  class="form-field"
                  style="margin-top: 20px"
                  *ngIf="
                    birthdayCardFormControl.value &&
                    selectedBirthdayRewardType === 'points'
                  "
                >
                  <div class="form-field-label">
                    {{ birthdayQuantityLabel }}<span style="color: red">*</span>
                  </div>
                  <input
                    class="form-input"
                    autocomplete="off"
                    [maxlength]="7"
                    [formControl]="birthdayQuantityFormControl"
                    type="number"
                    placeholder="Enter number of points"
                    min="1"
                    oninput="
                      javascript: if (this.value.length > this.maxLength)
                        this.value = this.value.slice(0, this.maxLength);
                    "
                  />
                </div>

                <div
                  class="form-field"
                  style="margin-top: 20px"
                  *ngIf="
                    birthdayCardFormControl.value &&
                    selectedBirthdayRewardType === 'stamps'
                  "
                >
                  <single-select
                    [label]="birthdayQuantityLabel"
                    [formCtrl]="birthdayQuantityFormControl"
                    [options]="birthdayStampOptions"
                    [value]="birthdayQuantityFormControl.value"
                    property="number"
                    [showIcon]="false"
                  ></single-select>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="birthday-club-disabled" *ngIf="!hasBirthdayClubAccess">
        <img
          src="../../../../assets/padlock.png"
          width="80px"
          style="margin-bottom: 20px"
        />

        <p style="margin-bottom: 20px; font-weight: bold; font-size: 16px">
          {{ title }}
        </p>

        <p style="margin-bottom: 20px">
          {{ subtitle }}
        </p>

        <app-primary-button
          *ngIf="canEngage"
          [title]="'Upgrade Now'"
          (tapped)="seePlans()"
          bgColor="var(--app-timber)"
          color="white"
        ></app-primary-button>
      </div>
    </div>
  </ng-template>
</div>

<div mat-dialog-actions align="end" *ngIf="!loading && hasBirthdayClubAccess">
  <app-secondary-button
    style="margin-right: 10px"
    [title]="'Close'"
    [disabled]="false"
    (tapped)="matDialogRef.close()"
  ></app-secondary-button>

  <app-primary-button
    *ngIf="selectedTab === 'birthday'"
    [disabled]="!merchantActive"
    [tooltip]="!merchantActive ? 'Merchant account inactive' : ''"
    [title]="'Save'"
    (tapped)="save()"
    bgColor="var(--app-timber)"
    color="white"
  ></app-primary-button>
</div>

<loader [loading]="saving || loading"></loader>
